var _line, _line2, _circle, _circle2, _path, _path2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounter2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 13,
    viewBox: "0 0 51 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 6.5,
    x2: 30,
    y2: 6.5,
    stroke: "#63B993"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 6.5,
    x2: 11,
    y2: 6.5,
    stroke: "#17EFB0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 6.5,
    r: 6,
    transform: "rotate(90 44.5 6.5)",
    fill: "white",
    stroke: "#63B993"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 6.5,
    r: 6,
    transform: "rotate(90 25.5 6.5)",
    fill: "white",
    stroke: "#63B993"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8476 4.1464C47.9414 4.24017 47.994 4.36733 47.994 4.49991C47.994 4.6325 47.9414 4.75966 47.8476 4.85343L43.8475 8.8536C43.7537 8.94734 43.6266 9 43.494 9C43.3614 9 43.2342 8.94734 43.1404 8.8536L41.1404 6.85351C41.0493 6.75921 40.9989 6.6329 41 6.5018C41.0012 6.3707 41.0537 6.24528 41.1465 6.15258C41.2392 6.05987 41.3646 6.00728 41.4957 6.00614C41.6268 6.005 41.7531 6.0554 41.8474 6.14648L43.494 7.79306L47.1406 4.1464C47.2344 4.05266 47.3615 4 47.4941 4C47.6267 4 47.7539 4.05266 47.8476 4.1464Z",
    fill: "#63B993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8476 4.1464C28.9414 4.24017 28.994 4.36733 28.994 4.49991C28.994 4.6325 28.9414 4.75966 28.8476 4.85343L24.8475 8.8536C24.7537 8.94734 24.6266 9 24.494 9C24.3614 9 24.2342 8.94734 24.1404 8.8536L22.1404 6.85351C22.0493 6.75921 21.9989 6.6329 22 6.5018C22.0012 6.3707 22.0537 6.24528 22.1465 6.15258C22.2392 6.05987 22.3646 6.00728 22.4957 6.00614C22.6268 6.005 22.7531 6.0554 22.8474 6.14648L24.494 7.79306L28.1406 4.1464C28.2344 4.05266 28.3615 4 28.4941 4C28.6267 4 28.7539 4.05266 28.8476 4.1464Z",
    fill: "#63B993"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5.75,
    transform: "rotate(90 6.5 6.5)",
    fill: "white",
    stroke: "#63B993",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 3.5,
    transform: "rotate(90 6.5 6.5)",
    fill: "#63B993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter2);
export default __webpack_public_path__ + "static/media/counter2.101310f1c5ff592203ae534feed84bbd.svg";
export { ForwardRef as ReactComponent };